export default __webpack_public_path__ + "static/media/Gakken-Philippines-Logo.76a0cd4d.png";